export enum ActionType {
	SET_CURRENT_USER = "SET_CURRENT_USER",
	SET_LETTER_TABLE_FILTERS = "SET_LETTER_TABLE_FILTERS",
	SET_IS_MOBILE="SET_IS_MOBILE",
	SET_IS_DESKTOP="SET_IS_DESKTOP"
}
